import { render, staticRenderFns } from "./Detention.vue?vue&type=template&id=7d330690&"
import script from "./Detention.vue?vue&type=script&lang=js&"
export * from "./Detention.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports